export default class GoogleMyBusinessService {
  constructor(context, locationId, fromDate, toDate) {
    this.context = context;
    this.axios = this.context.$axios;
    this.locationId = locationId;
    this.fromDate = fromDate;
    this.toDate = toDate;
  }

  gmbAccount = process.env.GMB_ACCOUNT;
  locationId = 0;
  fromDate = "";
  toDate = "";
  dailymetrics = {
    totalImpressions: 0,
    totalClicks: 0,
    totalCallClicks: 0,
    totalWebsiteClicks: 0,
    totalDirectionRequest: 0,
    totalSearchImpressions: 0,
    totalMapImpressions: 0,
    totalClicksAddress: 0
  };
  impressionsAndClicks = [];
  totalReviewCount = 0;

  async getDailyMetrics() {
    const dailymetrics = await this.axios.get(
      `${process.env.VUE_APP_API_GMB_URL_GOOGLE}/dailymetrics/${this.locationId}?fromDate=${this.fromDate}&toDate=${this.toDate}`
    );

    for (const key of dailymetrics.data) {
      if (key.name.includes("DIRECTION_REQUESTS")) this.dailymetrics.totalDirectionRequest += key.total;
      if (key.name.includes("WEBSITE_CLICKS")) this.dailymetrics.totalWebsiteClicks += key.total;
      if (key.name.includes("SEARCH")) this.dailymetrics.totalSearchImpressions += key.total;
      if (key.name.includes("IMPRESSIONS")) this.dailymetrics.totalImpressions += key.total;
      if (key.name.includes("CALL_CLICKS")) this.dailymetrics.totalCallClicks += key.total;
      if (key.name.includes("MAPS")) this.dailymetrics.totalMapImpressions += key.total;
      if (key.name.includes("CLICKS")) this.dailymetrics.totalClicks += key.total;
    }
    this.dailymetrics.totalClicks =
      this.dailymetrics.totalCallClicks +
      this.dailymetrics.totalWebsiteClicks +
      this.dailymetrics.totalDirectionRequest;
  }

  async getDailyMetricsByDays() {
    const dailymetricsByDays = await this.axios.get(
      `${process.env.VUE_APP_API_GMB_URL_GOOGLE}/dailymetrics-by-day/${this.locationId}?fromDate=${this.fromDate}&toDate=${this.toDate}`
    );

    if (dailymetricsByDays.data)
      this.impressionsAndClicks = dailymetricsByDays.data;
  }

  async getReviewsCount() {
    const reviewCount = await this.axios.get(
      `${process.env.VUE_APP_API_GMB_URL_GOOGLE}/reviewsmetrics/${process.env.VUE_APP_GMB_ACCOUNT}/${this.locationId}?fromDate=${this.fromDate}&toDate=${this.toDate}`
    );

    if (reviewCount.data)
      this.totalReviewCount = reviewCount.data.reviews.totalReveiws || 0;
  }

  async getGoogleMyBusinessDataProfile() {
    try {
      if (this.locationId == 0) {
        return [];
      }

      await this.getDailyMetrics();
      await this.getDailyMetricsByDays();
      await this.getReviewsCount();

      const result = {
        impressionsAndClicks: this.impressionsAndClicks,
        totalReviewCount: this.totalReviewCount,
        ...this.dailymetrics
      };

      return result;
    } catch (err) {
      console.log(`Error in request to GMB Daily metrics:${err}`);
      return {
        impressionsAndClicks: this.impressionsAndClicks,
        totalReviewCount: this.totalReviewCount,
        ...this.dailymetrics
      };
    }
  }
}
